export default "__VITE_ASSET__BYMGrO15__"